import { Button, Drawer, Skeleton, Checkbox, TreeSelect, Card, Spin } from "antd";
import { useState, useEffect, useRef } from "react";
import ReactApexChart from "react-apexcharts";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../../Elements/TreeSelect/TreeSelectCustom";
import { calculateDateRangeFromDate } from "../../../../../../../Utils/DateConverstion";
import { useSelector } from "react-redux";
import * as echarts from 'echarts';



const TempLiveChart = () => { 
  const chartRef = useRef(null);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState(); 
  const [selectedMeterIds, setSelectedMeterIds] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [seriesChartData, setSeriesChartData] = useState([]);
  const [chartTime, setChartTime] = useState();
  const [singleMeterName, setSingleMeterName] = useState();
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [chartSkip, setChartSkip] = useState(true);  
  const [chartInput, setChartInput] = useState();
  const [submitClicked, setSubmitClicked] = useState(false);
  const [flowSectionList, setFlowSectionList] = useState([]);
  const [flowConverterList, setFlowConverterList] = useState([]);

  const [flowGroupDetailList, setFlowGroupDetailList] = useState([]);
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
  const [steamGroupMeterList, setSteamGroupMeterList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const [loading, setLoading] = useState(true);
  const simulateLoading = (setLoading) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 seconds
  };

  useEffect(()=>{
    simulateLoading(setLoading); 
  },[])


  const [steamConverterLiveChartData, setSteamConverterLiveChartData] =
    useState([]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const dummyResponse = [
    {
        "sitE_ID": 9,
        "workstation": "SalComp",
        "sitename": "S9",
        "comport": "com4",
        "baudrate": "4200",
        "databits": "",
        "parity": "none",
        "stopbit": "1",
        "delete_yn": 1,
        "siteIP": "192.168.0.14",
        "port": "4001",
        "noofPorts": 1,
        "electricityModule": 0,
        "steamModule": 0,
        "waterModule": 0,
        "airModule": 0,
        "gasModule": 0,
        "temperatureModule": 0
    },
    {
        "sitE_ID": 10,
        "workstation": "SalComp",
        "sitename": "S10",
        "comport": "com4",
        "baudrate": "4200",
        "databits": "",
        "parity": "none",
        "stopbit": "1",
        "delete_yn": 1,
        "siteIP": "192.168.0.12",
        "port": "4001",
        "noofPorts": 1,
        "electricityModule": 0,
        "steamModule": 0,
        "waterModule": 0,
        "airModule": 0,
        "gasModule": 0,
        "temperatureModule": 0
    }
]
  // const [chartData, setChartData] = useState({
  //   series: [
  //     {
  //       name: "",
  //       data: [], 
  //     },
  //   ],

  //   options: {
  //     chart: {
  //       height: 350,
  //       type: "line",
  //       zoom: {
  //         type: "x",
  //         enabled: true,
  //         // autoScaleYaxis: true,
  //       },
  //       animations: {
  //         enabled: true,
  //         easing: "linear",
  //         dynamicAnimation: {
  //           speed: 1,
  //         },
  //       },
  //       toolbar: {
  //         autoSelected: "zoom",
  //       },
  //     },
  //     colors: [
  //       '#FF5733', '#33FF57', '#3357FF', '#F3FF33', '#33FFF9', '#FF33A6', '#B833FF','#FF8D33', '#33FF8D', '#FF3381', '#3381FF', '#FFDB33', '#33FFDB', '#FF7033', '#33FF70','#7033FF', '#FF33C9', '#33FFC9', '#C933FF'
  //     ],
  //     legend: {
  //       show: true,
  //       showForSingleSeries: true,
  //       showForNullSeries: true,
  //       showForZeroSeries: true,
  //       position: 'bottom',
  //       horizontalAlign: 'center', 
  //       floating: false,
  //       fontSize: '14px',
  //       fontFamily: 'Helvetica, Arial',
  //       fontWeight: 400,
  //       formatter: undefined,
  //       inverseOrder: false,
  //       width: undefined,
  //       height: undefined,
  //       tooltipHoverFormatter: undefined,
  //       customLegendItems: [],
  //       offsetX: 0,
  //       offsetY: 0,
  //       labels: {
  //           colors:  isdarkMode ? "#FFFFFF" : "#000000",
  //           useSeriesColors: false
  //       },
  //       markers: {
  //           width: 12,
  //           height: 12,
  //           strokeWidth: 0,
  //           strokeColor: '#fff',
  //           fillColors: undefined,
  //           radius: 12,
  //           customHTML: undefined,
  //           onClick: undefined,
  //           offsetX: 0,
  //           offsetY: 0
  //       },
  //       itemMargin: {
  //           horizontal: 5,
  //           vertical: 10
  //       },
  //       onItemClick: {
  //           toggleDataSeries: true
  //       },
  //       onItemHover: {
  //           highlightDataSeries: false
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false,
  //     },
  //     stroke: {
  //       curve: "smooth",
  //     },
  //     markers: {
  //       size: 5,
  //       sizeOffset: 0,
  //       hover: {
  //         size: undefined,
  //         sizeOffset: 3,
  //       },
  //     },
  //     // title: {
  //     //   text: "Live Trends Chart",
  //     //   align: "left",
  //     // },

  //     // xaxis: {
  //     //   categories: [],
  //     //   labels: {
  //     //     format: "dd-MMM",
  //     //   },
  //     //   title: {
  //     //     text: "Date",
  //     //   },
  //     // },
  //     title: {
  //       // display: true,
  //       text: "Live Trends Chart",
  //       // color:  'red',

  //       style: {
  //         color: isdarkMode ? "#FFFFFF" : "#000000",
  //             // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
  //          fontSize: "18px", 
  //          fontWeight: "bold" },
        
  //     },
  //     xaxis: {
  //       categories: [],
  //       labels: { 
  //         style: {
  //           colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
  //         },
  //       },
  //       title: { 
  //         text: "Date", 
  //         style: {
  //           color: isdarkMode ? "#FFFFFF" : "#000000",
  //         }
  //       }
  //     },
  //     yaxis: {
  //       labels: {
  //         style: {
  //           colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],  // White for dark mode, black for light mode
  //         },
  //       },
  //       title: { 
  //         text: "Value",
  //         style: {
  //           color: isdarkMode ? "#FFFFFF" : "#000000",  // White for dark mode, black for light mode
  //         },
  //       },
  //     },
       
  //     tooltip: {
  //       x: {
  //         show: true,
  //         format: "dd MMM",
  //         formatter: undefined,
  //       },
  //       y: {
  //         title: {
  //           formatter: (
  //             seriesName,
  //             { series, seriesIndex, dataPointIndex, w }
  //           ) => {
  //             const isFlowRate = seriesName.includes("flowRate");
  //             const kgLabel = isFlowRate ? " (°C)" : "(°C)";

  //             // Assuming opts.value contains the actual y-axis value
  //             return seriesName + kgLabel;
  //             // return seriesName + kgLabel;
  //           },
  //         },
  //       },
  //     },
  //   },
  // });

  const demoData = [
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:56:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:56:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:55:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:55:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:54:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:54:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:53:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:53:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:52:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:52:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:51:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:51:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 67,
      "temperature": 22,
      "createdON": "2024-06-25T01:50:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 67,
      "temperature": 22,
      "createdON": "2024-06-25T01:50:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:49:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:49:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 58,
      "temperature": 22,
      "createdON": "2024-06-25T01:48:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 58,
      "temperature": 22,
      "createdON": "2024-06-25T01:48:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:47:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:47:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:46:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:46:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:45:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:45:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:44:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:44:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:43:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:43:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:42:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:42:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:41:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:41:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:40:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:40:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 60,
      "temperature": 22,
      "createdON": "2024-06-25T01:39:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 60,
      "temperature": 22,
      "createdON": "2024-06-25T01:39:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:38:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:38:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:37:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:37:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:36:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:36:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:35:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:35:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:34:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:34:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:33:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:33:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:32:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:32:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 58,
      "temperature": 22,
      "createdON": "2024-06-25T01:31:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 58,
      "temperature": 22,
      "createdON": "2024-06-25T01:31:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:30:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:30:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:29:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:29:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:28:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:28:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:27:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:27:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:26:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 72,
      "temperature": 22,
      "createdON": "2024-06-25T01:26:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:25:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:25:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:24:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:24:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:23:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 61,
      "temperature": 22,
      "createdON": "2024-06-25T01:23:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 59,
      "temperature": 22,
      "createdON": "2024-06-25T01:22:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 59,
      "temperature": 22,
      "createdON": "2024-06-25T01:22:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 62,
      "temperature": 22,
      "createdON": "2024-06-25T01:21:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 62,
      "temperature": 22,
      "createdON": "2024-06-25T01:21:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 65,
      "temperature": 22,
      "createdON": "2024-06-25T01:20:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 65,
      "temperature": 22,
      "createdON": "2024-06-25T01:20:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:19:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T01:19:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:18:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:18:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:17:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:17:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:16:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:16:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:15:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:15:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 58,
      "temperature": 22,
      "createdON": "2024-06-25T01:14:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 58,
      "temperature": 22,
      "createdON": "2024-06-25T01:14:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 59,
      "temperature": 22,
      "createdON": "2024-06-25T01:13:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 59,
      "temperature": 22,
      "createdON": "2024-06-25T01:13:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 62,
      "temperature": 22,
      "createdON": "2024-06-25T01:12:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 62,
      "temperature": 22,
      "createdON": "2024-06-25T01:12:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:11:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 66,
      "temperature": 22,
      "createdON": "2024-06-25T01:11:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:10:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:10:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:09:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:09:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:08:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 71,
      "temperature": 22,
      "createdON": "2024-06-25T01:08:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:07:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:07:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:06:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 64,
      "temperature": 22,
      "createdON": "2024-06-25T01:06:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 59,
      "temperature": 22,
      "createdON": "2024-06-25T01:05:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 59,
      "temperature": 22,
      "createdON": "2024-06-25T01:05:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 60,
      "temperature": 22,
      "createdON": "2024-06-25T01:04:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 60,
      "temperature": 22,
      "createdON": "2024-06-25T01:04:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:03:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 63,
      "temperature": 22,
      "createdON": "2024-06-25T01:03:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:02:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 68,
      "temperature": 22,
      "createdON": "2024-06-25T01:02:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:01:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:01:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:00:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 73,
      "temperature": 22,
      "createdON": "2024-06-25T01:00:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T00:59:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 70,
      "temperature": 22,
      "createdON": "2024-06-25T00:59:00"
    },
    {
      "sitename": "M30",
      "meterid": 1,
      "metername": "Temp- FM34",
      "rh": 67,
      "temperature": 22,
      "createdON": "2024-06-25T00:58:00"
    },
    {
      "sitename": "M30",
      "meterid": 9,
      "metername": "Temp- FM530",
      "rh": 67,
      "temperature": 22,
      "createdON": "2024-06-25T00:58:00"
    }
  ]



  const fetchSteamConverterLive = (input) => {
    const url = `${APIConstants.GET_LIVE_TRENDS_TEMPERATURE}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    // const url = `${APIConstants.GET_LIVE_TRENDS_TEMPERATURE}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=2024-06-25 00:57:00.000&Todate=2024-06-25 01:57:00.000`;

    // const url1 = `http://20.244.40.160:81/Livetemperature?SectionID=1&ConverterorGroupID=1,&MeterIds=1&FromDate=2024-06-25 00:57:00.000&Todate=2024-06-25 01:57:00.000`

    console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
    }).then((res) => {
      console.log(res)
      // const resss = res.map(item => {
      //   return {
      //     ...item, 
      //     flowRate: item.rh,
      //     cumulative: item.temperature,
      //     rh: undefined,          // Optionally remove the original `rh`
      //     temperature: undefined  // Optionally remove the original `temperature`
      //   };
      // });
      if (res.length>0) {
        setSteamConverterLiveChartData(res);
      }
      setIsLoading(false)
      console.log(res);
    });
  };



  useEffect(() => {
    if (chartInput) {
        fetchSteamConverterLive(chartInput);
    }
  }, [chartInput]);

//to fetch meter upon converter selection 
  const fetchNsFlow= (id) => {
    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.TEMP_METERS_LIST}?SiteID=${id}`
    }).then((res) => {
      console.log(res)
      // setNsFlowConverterList(res);
      setNsFlowConverterList(res);
    });
  };

  
  useEffect(() => {
    if (converterGroupId) {
      fetchNsFlow(converterGroupId);
    }
  }, [converterGroupId]);



  //to fetch metrs upon group selection
  const fetchGroupMeter= (id) => {
   
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${id}`
    }).then((res) => {
      console.log(res)
      setSteamGroupMeterList(res);
    });
  };

  
  useEffect(() => {
    if (converterGroupId) {
      fetchGroupMeter(converterGroupId);
    }
  }, [converterGroupId]);

  const conveter =[
    {
      "sitE_ID": 9,
      "workstation": "SalComp",
      "sitename": "S9",
      "comport": "com4",
      "baudrate": "4200",
      "databits": "",
      "parity": "none",
      "stopbit": "1",
      "delete_yn": 1,
      "siteIP": "192.168.0.14",
      "port": "4001",
      "noofPorts": 1,
      "electricityModule": 0,
      "steamModule": 0,
      "waterModule": 0,
      "airModule": 0,
      "gasModule": 0,
      "temperatureModule": 0
    },
    {
      "sitE_ID": 10,
      "workstation": "SalComp",
      "sitename": "S10",
      "comport": "com4",
      "baudrate": "4200",
      "databits": "",
      "parity": "none",
      "stopbit": "1",
      "delete_yn": 1,
      "siteIP": "192.168.0.12",
      "port": "4001",
      "noofPorts": 1,
      "electricityModule": 0,
      "steamModule": 0,
      "waterModule": 0,
      "airModule": 0,
      "gasModule": 0,
      "temperatureModule": 0
    }
  ]


  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
    }).then((res) => {
        console.log(res)
      setFlowSectionList(res);
    });
    // http://20.244.40.160:81/TVSDashBoard/Getsites
    // http://20.244.40.160:81/TVSDashBoard/Getsites

makeRequest({
      type: APIConstants.GET,
      // url: APIConstants.GET_FLOW_CONVERTER_DETAILS,
      url: APIConstants.TEMP_GETSITES,
    }).then((res) => {
      console.log(res)
      // console.log(conveter)
      // setFlowConverterList(conveter);
      setFlowConverterList(res);
    });

makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
    }).then((res) => {
      console.log(res)
      setFlowGroupDetailList(res);
    });
  },[]);

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const setChartInputData = () => {
    localStorage.setItem("secId", Number(sectionId || 1));
    localStorage.setItem("ConverterorGroupID", Number(converterGroupId || 3));
    localStorage.setItem("meterIds", JSON.stringify(selectedMeterIds || ["1"]));
    localStorage.setItem(
      "parameters",
      JSON.stringify(selectedValues || ["rh"])
    );

    const currentDate = new Date();
    // console.log(currentDate)
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    console.log(from ,to)
    // console.log(currentDate)

    const lgSecId = localStorage.getItem("secId");
    const lgConvId = localStorage.getItem("ConverterorGroupID");
    const meterId = localStorage.getItem("meterIds");

    const inputIds = JSON.parse(meterId).map((item) => item);
    const ids = inputIds?.map((id) => id).join(",");

    const inputData = {
      SectionID: Number(lgSecId),
      ConverterorGroupID: Number(lgConvId),
      MeterIds: ids,
      FromDate:  from|| '2024-06-25 00:57:00.000',
      ToDate: to|| '2024-06-25 01:57:00.000',
    };

    const queryString = (inputData);
    setChartInput(queryString);
  };

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    setSubmitClicked(false);
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    console.log(changedValues)
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    setSubmitClicked(false);
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    setSubmitClicked(false);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    setSubmitClicked(false);
    if (values) {
      setParaError("");
    }
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  const updateChart = async (data) => {
    const meterId = localStorage.getItem("meterIds");
    const inputIds = JSON.parse(meterId)?.map((item) => item);
    console.log(inputIds)

    // filter data based on selected meters
    const filterMeterData = () => {
      const selectedMeterData = steamConverterLiveChartData?.filter((item) =>
        inputIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      return selectedMeterData;
    };

    // transform the data in a chart series format
    const transformData = (property, meterName) => {
      const data = filterMeterData()
        ?.filter((item) => item?.metername === meterName)
        ?.map((item) => item[property]);
      data?.reverse();

      const seriesData = {
          type:'line',
          name: `${property}-${meterName}`, // Concatenate property and METERNAME
          stack: 'Total',
          data,
      };

      return seriesData;
    };

    const getChartSeriesData = () => {
      const properties = selectedValues?.length ? selectedValues : ["rh"];
      const seriesDataArray = [];

      // Iterate over selected meter IDs and properties
      inputIds?.forEach((id) => {
        const meterName = filterMeterData()?.find(
          (item) => item?.meterid === Number(id)
        )?.metername;

        properties.forEach((property) => {
          seriesDataArray.push(transformData(property, meterName));
        });
      });
      return seriesDataArray;
    };

    const getChartDate = () => {
      const dateArray = [];
      const date = ["createdON"];
      inputIds?.forEach((id) => {
        const meterName = filterMeterData()?.find(
          (item) => item?.meterid === Number(id)
        )?.metername;

        date?.forEach((property) => {
          dateArray.push(transformData(property, meterName));
        });
      });
      // Find the array with the maximum length
      const longestArray = dateArray.reduce((maxArray, currentArray) => {
        return currentArray?.data?.length > maxArray?.data?.length
          ? currentArray
          : maxArray;
      }, dateArray[0] || []);
      return longestArray?.data?.reverse();
    };

    const finalSeriesData = () => {
      const firstOption = selectedValues?.includes("rh");
      const secondOption = selectedValues?.includes("temperature");

      const finalData = getChartSeriesData()?.filter((series) => {
        if (firstOption && secondOption) {
          // Both options selected, keep all series
          return true;
        } else if (firstOption) {
          // First option selected, add series with "rh"
          return series.name.includes("rh");
        } else if (secondOption) {
          // Second option selected, add series with "temperature"
          return series.name.includes("temperature");
        }
        // If neither option selected, keep all series
        return false;
      });
      return finalData;
    };

    const reversedDate = getChartDate();
    const localDateTime = reversedDate?.map((date) =>
      new Date(date).toLocaleString()
    );

    const finalSeries = finalSeriesData();
    setSingleMeterName(finalSeries[0]?.name);
    console.log(finalSeries);

    setSeriesChartData(finalSeries);
    setChartTime(localDateTime);
  };

  useEffect(() => {
    setChartSkip(false);
    updateChart();
    const interval = setInterval(() => {
      // refetchChart();
      updateChart();
    }, [600000]);

    return () => {
      clearInterval(interval);
    };
  }, [ steamConverterLiveChartData]);

  // useEffect(() => {
  //   if (!steamConverterLiveChartData) {
  //     updateChart();
  //   }
  // }, [steamConverterLiveChartData]);

  // useEffect(() => {
  //   setChartData((prevChartData) => ({
  //     series: seriesChartData || [],
  //     options: {
  //       ...prevChartData.options,
  //       xaxis: {
  //         ...prevChartData.options.xaxis,
  //         categories: chartTime ? chartTime.reverse() : [],
  //       },
  //       yaxis: {
  //         title: {
  //           text: selectedValues.join(",".toString()),
  //         },
  //       },
  //     },
  //   }));
  // }, [seriesChartData, chartTime]);

  // useEffect(() => {
  //   setChartData((prevChartData) => ({
  //     series: prevChartData.series || [],
  //     options: { 
  //       ...prevChartData.options,
  //       chart:{
  //         background:` ${isdarkMode ? '#2d3748':'inherit'}`
  //     },
  //       legend: {
  //         ...prevChartData.options.legend,
  //         labels: {
  //           ...prevChartData.options.legend.labels,
  //           colors: isdarkMode ? "#FFFFFF" : "#000000", // Adjust legend label color
  //         },
  //       },
  //       xaxis: {
  //         ...prevChartData.options.xaxis,
  //         labels: {
  //           ...prevChartData.options.xaxis.labels,
  //           style: {
  //             colors: isdarkMode ? "#FFFFFF" : "#000000", // Adjust x-axis label color
  //           },
  //         },
  //         title: {
  //           ...prevChartData.options.xaxis.title,
  //           style: {
  //             color: isdarkMode ? "#FFFFFF" : "#000000", // Adjust x-axis title color
  //           },
  //         }, 
  //       },
  //       yaxis: {
  //         ...prevChartData.options.yaxis,
  //         labels: {
  //           ...prevChartData.options.yaxis.labels,
  //           style: {
  //             colors: isdarkMode ? "#FFFFFF" : "#000000", // Set y-axis label color to white in dark mode
  //           },
  //         },
  //         title: {
  //           ...prevChartData.options.yaxis.title,
  //           style: {
  //             color: isdarkMode ? "#FFFFFF" : "#000000", // Set y-axis title color to white in dark mode
  //           },
  //         },
  //       },
  //       title: {
  //         ...prevChartData.options.title,
  //         style: {
  //           color: isdarkMode ? "#FFFFFF" : "#000000", // Adjust chart title color
  //         },
  //       },
  //     },
  //   }));
  // }, [isdarkMode,chartData]);
  

  const parameters = [
    { id: 1, name: "rh" },
    { id: 2, name: "temperature" },
  ];

  const isInvalid = singleMeterName?.split("-");

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds, "Meter");
    const paraError = validateInput(selectedValues, "Parameter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setIsLoading(true)

    if (!sectionError && !converterError && !meterError && !paraError) {
      setChartInputData();
      setSubmitClicked(true);
      // setIsLoading(false)
      onClose();
    }
  }; 
 
  useEffect(() => {
    const timer = setInterval(() => {
      if (
        submitClicked &&
        converterGroupId &&
        sectionId &&
        selectedMeterIds?.length &&
        selectedValues?.length
      ) {
        setChartInputData();
      }
    }, 10000);
    return () => clearInterval(timer);
  }, [
    // converterGroupId,
    // sectionId,
    // selectedMeterIds,
    // submitClicked,
    // selectedValues,
  ]);
  // console.log(chartData.options); 
  // console.log(chartData.series); 


  useEffect(() => {
    // if (!chartRef.current || barChartData.length === 0) return;
    console.log(chartTime)
    console.log(seriesChartData)  

    if(chartTime && seriesChartData.length>0){
      const myChart = echarts.init(chartRef.current);

    // Option for the chart     
    const option = {
      backgroundColor: isdarkMode ? '#2d3748' : '#fff', 
      title: {
        text: `Live Trends`,
        left: 'center',
        top: '5px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black' 
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'line'  
        }
      },
      toolbox: {
        show: true,
        feature: {
          magicType: { 
            type: ['line', 'bar'],
            iconStyle: {
              borderColor: isdarkMode ? 'white' : 'black'  // Icons for line/bar type switch
            }
          },
          saveAsImage: {
            title: 'Save Image',
            iconStyle: {
              borderColor: isdarkMode ? 'white' : 'black'  // Save image icon color
            }
          }
        },
        iconStyle: {
          borderColor: isdarkMode ? 'white' : 'black'  // General icon color based on theme
        }
      },
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black' 
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '20%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: chartTime,  // Assuming seriesChartData contains the x-axis labels
        axisLabel: {
          color: isdarkMode ? 'white' : 'black',  // Change x-axis label color based on theme
          interval: 3,
          rotate: 45,  // Rotate labels by 45 degrees to prevent overlap
          formatter: function (value) {
            return value;
          }
        },
        boundaryGap: false  // Ensure the line starts from the axis
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: isdarkMode ? 'white' : 'black',  // Change y-axis label color based on theme
          fontSize: '10',
          fontWeight: 'bold' 
        }
      },
      series: seriesChartData,  // Assuming chartTime contains the series data for the line chart
    };
    
    
    myChart.setOption(option);

    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);

    return () => {
        window.removeEventListener('resize', resizeHandler);
        myChart.dispose();
    };}
}, [chartTime,seriesChartData,isdarkMode]);

  return (
    <div id="chart"  className = {`relative  p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}> 
      {/* {isLoading  && (
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div>
      )} */}

      <Card
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
         {
          !seriesChartData.length && !loading >0 &&
          <div className="text-3xl">
          <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          </div> 
         }
           {loading  && (  
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
        <div ref={chartRef} className={`${loading ? 'h-0':'min-h-[650px]'} w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>

          </Card>
 
      
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? flowConverterList : flowGroupDetailList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsFlowConverterList
                : steamGroupMeterList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />

          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>

          <SteamTreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"
            nameKey="name"
            valueKey="name"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default TempLiveChart;
